import { curry } from 'lodash/fp';

export default funcsBySite => curry(funcsBySite[window.globalConfig.siteId]);
